"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlinkSymlink = unlinkSymlink;
exports.createSymlink = createSymlink;
exports.rename = rename;
exports.cleanup = cleanup;
const tslib_1 = require("tslib");
/**
 * @author Xiaofu Huang <xiaofhua@microsoft.com>
 */
const fs = tslib_1.__importStar(require("fs-extra"));
const helpLink_1 = require("../constant/helpLink");
const message_1 = require("../constant/message");
const depCheck_1 = require("../../../error/depCheck");
async function unlinkSymlink(linkFilePath, forceUpdate = false) {
    try {
        const stat = await fs.lstat(linkFilePath);
        if (stat.isSymbolicLink()) {
            await fs.unlink(linkFilePath);
        }
        else {
            if (forceUpdate) {
                // For regular file or directory, remove it
                await fs.remove(linkFilePath);
            }
        }
    }
    catch (error) {
        const statError = error;
        if (statError.code !== "ENOENT") {
            throw error;
        }
    }
}
async function createSymlink(target, linkFilePath, forceUpdate = false) {
    await unlinkSymlink(linkFilePath, forceUpdate);
    // check if destination already exists
    if (await fs.pathExists(linkFilePath)) {
        throw new depCheck_1.DepsCheckerError(message_1.Messages.symlinkDirAlreadyExist(linkFilePath), helpLink_1.v3DefaultHelpLink);
    }
    return await fs.ensureSymlink(target, linkFilePath, 
    /* Only used for Windows. Directory junction is similar to directory link but does not require admin permission. */
    "junction");
}
async function rename(oldPath, newPath) {
    if (await fs.pathExists(newPath)) {
        await fs.remove(newPath);
    }
    await fs.rename(oldPath, newPath);
}
// sliently remove file or dir
async function cleanup(path) {
    try {
        await fs.remove(path);
    }
    catch { }
}
//# sourceMappingURL=fileHelper.js.map